(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('TravelExpensesStatementListController', TravelExpensesStatementListController);

    TravelExpensesStatementListController.$inject = ['$uibModal', '$state', '$scope', 'TravelExpenseService', 'CurrentUser', 'SellerService', 'expenseTypeList', 'paymentTypeList'];

    function TravelExpensesStatementListController($uibModal, $state, $scope, TravelExpenseService, CurrentUser, SellerService, expenseTypeList, paymentTypeList) {
        var vm = this;

        /* Report Vars */
        vm.isApproved = [{
            id: -1,
            name: '--- All ---'
        }, {
            id: 1,
            name: 'Yes'
        }, {
            id: 0,
            name: 'No'
        }];
        vm.isApprovedSelected = -1;
        vm.currentUser = CurrentUser;
        vm.flag = false;
        vm.sellerSelected = '';
        vm.hasReceipt = [{
            id: -1,
            name: '--- All ---'
        }, {
            id: 1,
            name: 'Yes'
        }, {
            id: 0,
            name: 'No'
        }];
        vm.hasReceiptSelected = -1;
        vm.amount = 0.00;
        vm.description = '';
        vm.expenseTypeList = expenseTypeList;
        vm.paymentTypeList = paymentTypeList;
        vm.deleteStatement = deleteStatement;
        vm.statementLinked = 0;

        /* Datepicker */
        vm.statementDate = {
            startDate: '',
            endDate: ''
        };
        vm.datePicker = {
            "autoApply": true
        };
        vm.dateOptions = {
            locale: {
                format: 'MM/DD/YYYY',
                cancelLabel: 'Close'
            }
        };

        /* Methods */
        vm.getByFilter = getByFilter;
        vm.convertToUTC = convertToUTC;
        vm.selectSellers = selectSellers;
        vm.chooseExpense = chooseExpense;
        vm.viewTravelExpense = viewTravelExpense;
        vm.goToEditTravelExpense = goToEditTravelExpense;
        vm.goToCreateTravelExpense = goToCreateTravelExpense;

        /* Pagination */
        vm.pageChanged = pageChanged;
        vm.setPage = setPage;
        vm.totalItems = [];
        vm.to = [];
        vm.currentPage = null;
        vm.itemsPerPage = [];
        vm.page = 1;

        function activate() {
            vm.selectSellers();
            vm.getByFilter();
            if (!$scope.can('view_travel_expense_statements_seller_select')) {
                vm.sellerSelected = vm.currentUser.id;
            } else {
                vm.sellerSelected = -1;
            }
        }

        function convertToUTC(date) {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        }

        function selectSellers() {
            SellerService.getStaff().then(function (response) {
                vm.sellers = response.data;
                vm.sellers.unshift({
                    id: -1,
                    name: '--- All ---'
                });
            }).catch(function (err) {});
        }

        function getByFilter() {
            vm.flag = false;
            var query = {};

            if (TravelExpenseService.filters) {
                vm.statementDate = TravelExpenseService.filters.statementDate;
                vm.isApprovedSelected = TravelExpenseService.filters.isApprovedSelected;
                vm.amount = TravelExpenseService.filters.amount;
                vm.description = TravelExpenseService.filters.description;
                vm.currentUser = TravelExpenseService.filters.currentUser;
                vm.sellerSelected = TravelExpenseService.filters.sellerSelected;
                vm.hasReceiptSelected = TravelExpenseService.filters.hasReceiptSelected;
                vm.page = TravelExpenseService.filters.page;
            }

            TravelExpenseService.filters = null;

            query['page'] = vm.page;
            if (vm.statementDate.startDate != '' && vm.statementDate.endDate != '') {
                query['startDate'] = vm.convertToUTC(new Date(vm.statementDate.startDate));
                query['endDate'] = vm.convertToUTC(new Date(vm.statementDate.endDate));
            }
            if (vm.isApprovedSelected > -1) {
                query['approved'] = vm.isApprovedSelected;
            }
            if (vm.statementLinked > -1) {
                query['linked'] = vm.statementLinked;
            }
            if (vm.amount > 0) {
                query['amount'] = vm.amount;
            }
            if (vm.description != '') {
                query['description'] = vm.description;
            }
            if (!$scope.can('view_travel_expense_statements_seller_select')) {
                query['seller_id'] = vm.currentUser.id;
            } else {
                if (vm.sellerSelected > -1) {
                    query['seller_id'] = vm.sellerSelected;
                }
            }

            if (vm.hasReceiptSelected > -1) {
                query['has_receipt'] = vm.hasReceiptSelected;
            }
            TravelExpenseService.getStatements(query).then(function (response) {
                vm.flag = true;
                vm.statements = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function (err) {
                vm.flag = false;
            });
        }

        function chooseExpense(statement) {
            $uibModal.open({
                size: 'lg',
                templateUrl: 'templates/travelexpenses/statements/chooseExpense/chooseExpense.modal.html',
                controller: 'ChooseExpenseController',
                controllerAs: 'chooseExpense',
                resolve: {
                    statement: function () {
                        return statement;
                    },
                    expenseTypeList: function () {
                        return vm.expenseTypeList;
                    },
                    paymentTypeList: function () {
                        return vm.paymentTypeList;
                    },
                    travelExpensesStatementList: function () {
                        return vm;
                    }
                }
            });
        }

        function viewTravelExpense(expense) {
            $uibModal.open({
                templateUrl: 'templates/travelexpenses/viewTravelExpenseModal/viewTravelExpenseModal.html',
                controller: 'ViewTravelExpenseModalController',
                controllerAs: 'ViewTravelExpenseModal',
                resolve: {
                    expense: function () {
                        return expense;
                    },
                    mode: function () {
                        return 'edit';
                    },
                    expenseTypeList: function () {
                        return vm.expenseTypeList;
                    },
                    paymentTypeList: function () {
                        return vm.paymentTypeList;
                    }
                }
            });
        }

        function deleteStatement(statement) {
            alertify.confirm(
                'Delete Statement',
                'Do you really want to delete this statement?',
                function () {
                    TravelExpenseService.deleteStatement(statement.id)
                        .then(function (response) {
                            vm.statements.splice(vm.statements.indexOf(statement), 1);
                            alertify.success(response.data.message);
                        });
                },
                function () {
                    return true;
                }
            );
        }

        function goToCreateTravelExpense(statement) {
            let params = {
                statementId: statement.id
            };

            TravelExpenseService.setFilters(vm);
            $state.go("root.travel_expenses.create", params);
        }

        function goToEditTravelExpense(statement) {
            let params = {
                statementId: statement.id,
                expenseId: statement.travel_expense.id
            };

            TravelExpenseService.setFilters(vm);
            $state.go("root.travel_expenses.edit", params);
        }

        function setPage(pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged(pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        activate();
    }

})();